
import React from "react";
import { TableRow, TableCell } from "@/components/ui/table";
import { formatLevel2Distance } from "./utils/distanceFormatters";
import { getTendencyDisplay } from "./utils/tendencyUtils";

interface TablePointRowProps {
  point: string;
  scores: Record<string, (number | null)[]>;
  selectedTest: string | null;
  getPointTotal: (point: string) => number;
  getTestDistances: (testId: string) => Record<string, string>;
  isWedgingTest: boolean;
  isBunkerTest: boolean;
  isIronTest: boolean;
  isDriverTest: boolean;
}

const TablePointRow: React.FC<TablePointRowProps> = ({
  point,
  scores,
  selectedTest,
  getPointTotal,
  getTestDistances,
  isWedgingTest,
  isBunkerTest,
  isIronTest,
  isDriverTest,
}) => {
  const pointScores = scores[point] || Array(10).fill(null);
  
  // Get distances from getTestDistances function specific to level 2
  const distances = selectedTest ? getTestDistances(selectedTest) : {};
  
  // Format distance based on the point and test type
  const formattedDistance = formatLevel2Distance(
    point, 
    selectedTest, 
    distances, 
    isBunkerTest, 
    isWedgingTest
  );

  return (
    <TableRow key={point}>
      <TableCell className="font-medium">
        {point}
      </TableCell>
      <TableCell className="font-medium text-green-600">
        {formattedDistance}
      </TableCell>
      {Array.from({ length: 10 }, (_, i) => (
        <TableCell key={i} className="text-center">
          {(isIronTest || (selectedTest && selectedTest.includes('iron')) || 
            isDriverTest || (selectedTest && selectedTest.includes('driver'))) 
            ? getTendencyDisplay(point, i, scores, selectedTest, isIronTest, isDriverTest)
            : pointScores[i] !== null && pointScores[i] !== undefined
              ? pointScores[i]
              : '-'}
        </TableCell>
      ))}
      <TableCell className="text-center font-bold">
        {getPointTotal(point)}
      </TableCell>
    </TableRow>
  );
};

export default TablePointRow;
